import React, {Fragment, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Card, CardBody, CardFooter, Col, Row, Table} from "reactstrap";
import Pdf from "react-to-pdf";
import Loader from "../../../common/Loader";
import ButtonIcon from "../../../common/ButtonIcon";
import createMarkup from "../../../../helpers/createMarkup";
import {isIterableArray} from "../../../../helpers/utils";
import useFakeFetch from "../../../../hooks/useFakeFetch";
import rawInvoice from "../../../../data/invoice/invoice";
import logo from "../../../../assets/img/logos/logoCienytech.png";
import presupuestosService from "../../../../services/presupuestos.service";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {formatDate} from "../../../../helpers/cienytech.utils";
import usuariosService from "../../../../services/usuarios.service";
import {
    calcularDescuento,
    calcularPrecioConDescuento,
    calcularSubtotal,
    calcularTotal
} from "../../../../domain/presupuesto.domain";


const formatCurrency = number =>
  `${number
    .toFixed(2)
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
    .replace(",", ".")}`;


const ProductTr = ({
  producto,
  cantidadPedida,
  precioUnitario,
  porcentajeDescuento,
  nombreProducto
}) => {
  return (
    <tr>
      <td className="align-middle text-center">{cantidadPedida}</td>
      <td className="align-middle">{producto.referencia}</td>
      <td className="align-middle">{nombreProducto}</td>
      <td className="align-middle text-right">
        {formatCurrency(precioUnitario)}
      </td>
      <td className="align-middle text-right">
        {formatCurrency(cantidadPedida * precioUnitario)}
      </td>
      <td className="align-middle text-right">
        {formatCurrency(porcentajeDescuento)}
      </td>
      <td className="align-middle text-right">
        {formatCurrency(
            calcularPrecioConDescuento(cantidadPedida, precioUnitario, porcentajeDescuento)
        )}
      </td>
    </tr>
  );
};

ProductTr.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired
};

const InvoiceHeader = ({
  institution,
  logo,
  address,
  telefono,
  web,
  email
}) => (
  <Row className="align-items-center text-center mb-3">
    <Col sm={6} className="text-sm-left">
      <img src={logo} alt="Cienytech" width={350} />
    </Col>
    <Col className="text-sm-right mt-3 mt-sm-0">
      <h2 className="mb-3">Presupuesto</h2>
      <h5>{institution}</h5>
      {address && (
        <p
          className="fs--1 mb-0"
          dangerouslySetInnerHTML={createMarkup(address)}
        />
      )}
      <p className="fs--1 mb-0">
        Telf:{telefono} <br />
        <a href={web}>{web}</a> <br />
        <a href={`mailto:${email}`}>{email}</a>
      </p>
    </Col>
    <Col xs={12}>
      <hr />
    </Col>
  </Row>
);

InvoiceHeader.propTypes = {
  institution: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  address: PropTypes.string
};

const PrintPresupuesto = () => {
  const [subtotal, setSubtotal] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [total, setTotal] = useState(0);
  const [presupuesto, setPresupuesto] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { loading: invoiceLoading, data: invoice } = useFakeFetch(rawInvoice);
  const [usuario, setUsuario] = useState([]);
  const [firma, setFirma] = useState(undefined);
  let { id } = useParams();

  function recuperaPresupuesto() {
    if (presupuesto == null) {
      const user = JSON.parse(localStorage.getItem("user"));
      setUsuario(user);

      presupuestosService.getPresupuesto(id).then(
        response => {
          setPresupuesto(response.data);
          setIsLoading(false);
        },
        error => {
          toast.error("Error recuperando presupuesto");
          setIsLoading(false);
        }
      );

      recuperaFirma(user.codigoUsuario);
    }
  }

  function recuperaFirma(codigoUsuario) {
    if (firma == null) {
      usuariosService.getFirma(codigoUsuario).then(
        response => {
          setFirma(URL.createObjectURL(response.data));
          setIsLoading(false);
        },
        error => {
          toast.error("Error recuperando firma");
          setIsLoading(false);
        }
      );
    }
  }

  useEffect(() => {
    if (presupuesto && isIterableArray(presupuesto.productos)) {
      setSubtotal(calcularSubtotal(presupuesto.productos));
      setDescuento(calcularDescuento(presupuesto.productos));
      setTotal(calcularTotal(presupuesto.productos));
    }
  }, [presupuesto]);

  const ref = React.createRef();

  return (
    <Fragment>
      <div
        id="printframe"
        style={{ margin: "0 auto", height: "100%", width: "210mm" }}
      >
        <Card className="mb-3 d-print-none">
          <CardBody>
            <Row className="justify-content-between align-items-center">
              <Col md>
                <h5 className="mb-2 mb-md-0">
                  Presupuesto {isLoading ? "" : presupuesto.codigoPresupuesto}
                </h5>
              </Col>
              <Col xs="auto">
                <Pdf
                  targetRef={ref}
                  filename={
                    isLoading ? "" : presupuesto.codigoPresupuesto + ".pdf"
                  }
                >
                  {({ toPdf }) => (
                    <ButtonIcon
                      onClick={toPdf}
                      color="falcon-default"
                      size="sm"
                      icon="file-pdf"
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Descargar
                    </ButtonIcon>
                  )}
                </Pdf>

                <ButtonIcon
                  color="falcon-default"
                  size="sm"
                  icon="print"
                  className="mr-2 mb-2 mb-sm-0"
                  onClick={() => window.print()}
                >
                  Imprimir
                </ButtonIcon>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <div ref={ref}>
          <Card>
            <CardBody>
              {invoiceLoading ? (
                <Loader />
              ) : (
                <InvoiceHeader
                  institution={invoice.institution}
                  logo={logo}
                  address={invoice.address}
                  telefono={invoice.telefono}
                  web={invoice.web}
                  email={invoice.email}
                />
              )}

              {invoiceLoading ? (
                <Loader />
              ) : (
                <Row className="justify-content-between align-items-center">
                  <Col>
                    <h4>
                      {presupuesto.contacto.nombre}{" "}
                      {presupuesto.contacto.apellidos}
                    </h4>
                    <h5>{presupuesto.cliente.nombre}</h5>
                    <p
                      className="fs--1"
                      dangerouslySetInnerHTML={createMarkup(invoice.address)}
                    />
                    <p className="fs--1">
                      <a href={`mailto:${presupuesto.contacto.email}`}>
                        {presupuesto.contacto.email}
                      </a>
                      <br />
                      {presupuesto.contacto.telefono} -{" "}
                      {presupuesto.contacto.extension}
                    </p>
                  </Col>
                  <Col sm="auto" className="ml-auto">
                    <div className="table-responsive">
                      <Table size="sm" borderless className="fs--1">
                        <tbody>
                          <tr>
                            <th className="text-sm-right">
                              Nº de presupuesto:
                            </th>
                            <td className="text-dark">
                              <strong>{presupuesto.codigoPresupuesto}</strong>
                            </td>
                          </tr>
                          <tr>
                            <th className="text-sm-right">
                              Fecha Presupuesto:
                            </th>
                            <td className="text-dark">
                              <strong>{formatDate(presupuesto.fecha)}</strong>
                            </td>
                          </tr>
                          <tr>
                            <th className="text-sm-right">Nº de pedido:</th>
                            <td>{presupuesto.pedidoCliente}</td>
                          </tr>
                          <tr>
                            <th className="text-sm-right">Vigencia:</th>
                            <td>{presupuesto.vigencia}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              )}

              {invoiceLoading ? (
                <Loader />
              ) : (
                <div className="table-responsive mt-4 fs--1">
                  <Table striped className="border-bottom">
                    <thead>
                      <tr className="bg-secondary text-white">
                        <th className="border-0 text-center">
                          Cantidad Solicitada
                        </th>
                        <th className="border-0">Referencia Producto</th>
                        <th className="border-0">Descripción del Producto</th>
                        <th className="border-0 text-right">Precio Unitario</th>
                        <th className="border-0 text-right">Precio Total</th>
                        <th className="border-0 text-right">Dto %</th>
                        <th className="border-0 text-right">
                          Precio con Descuento
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isIterableArray(presupuesto.productos) &&
                        presupuesto.productos.map((product, index) => (
                          <ProductTr {...product} key={index} />
                        ))}
                    </tbody>
                  </Table>
                </div>
              )}

              {invoiceLoading ? (
                <Loader />
              ) : (
                <Fragment>
                  <Row noGutters className="justify-content-end">
                    <Col>
                      <Table size="sm" borderless className="fs--1">
                        <tbody>
                          <tr>
                            <td className="font-weight-bold">
                              NOTA: I.V.A. no incluído en los precios.
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-semi-bold">
                              Agradeciendo la confianza depositada en Cienytech
                              y esperando este presupuesto sea de su
                              conformidad, quedamos a la espera de su
                              autorización para la tramitación del pedido.
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-semi-bold">
                              Atentamente.
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <Col xs="auto">
                      <Table size="sm" borderless className="fs--1 text-right">
                        <tbody>
                          <tr>
                            <th className="text-900">Importe:</th>
                            <td className="font-weight-semi-bold">
                              {formatCurrency(subtotal)} €
                            </td>
                          </tr>
                          <tr>
                            <th className="text-900">Descuento:</th>
                            <td className="font-weight-semi-bold">
                              {formatCurrency(descuento)} €
                            </td>
                          </tr>
                          <tr className="border-top">
                            <th className="text-900">Total:</th>
                            <td className="font-weight-semi-bold">
                              {formatCurrency(total)} €
                            </td>
                          </tr>
                          <tr className="border-top border-2x font-weight-bold text-900">
                            <th>Importe a pagar:</th>
                            <td>{formatCurrency(total)} €</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <Row noGutters>
                    <Col>
                      <Table size="sm" borderless className="fs--1 text-center">
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src={firma}
                                alt={"José Benito Sebe Iglesias"}
                                style={{
                                  maxHeight: "250px",
                                  maxWidth: "250px"
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th className="text-900">
                              {usuario.nombre} {usuario.apellidos}
                            </th>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </CardBody>
            <CardFooter className="bg-light">
              <h6 class="text-center">POLÍTICA DE DEVOLUCIONES CIENYTECH</h6>
              <p className="fs--1 mb-0">
                Una vez recibida la mercancía, el cliente dispone de un plazo
                máximo de 5 días desde la fecha de entrega para la revisión de
                la mercancia entregada.{" "}
                <strong>
                  {" "}
                  No se admitirán reclamaciones ni devoluciones posteriores a
                  este plazo
                </strong>
                . <br />
                Para las reclamaciones dentro del plazo indicado, Cienytech se
                reserva el derecho a aceptar devoluciones del producto, siempre
                y cuando el error no sea imputable a Cienytech. En el caso de
                aceptación de devolución el cliente se hará cargo del envío del
                producto hasta nuestro almacén del artículo en perfecto estado y
                en su embalaje original. Cienytech abonará el 85% del valor de
                la mercancía.
                <br />
                En caso de que el error no sea imputable al cliente o si la
                mercancía llega deteriorada, Cienytech se hará cargo de la
                recogida y del abono total o reposición de la mercancía.
              </p>
            </CardFooter>
          </Card>
        </div>
      </div>
    </Fragment>
  );
};

export default PrintPresupuesto;
